import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@omilia/providers';
import { CheckCircleOutlineIcon } from '@omilia/icon';
import { colors } from '@omilia/theme';

const SWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 16px 0;
  width: 100%;
`;

const SContainer = styled.div`
  align-items: center;
  background-color: ${colors.COLOR_OMILIA_PURPLE_200};
  border-radius: 12px;
  color: ${colors.COLOR_OMILIA_PURPLE_900};
  display: inline-flex;
  font-size: 14px;
  gap: 6px;
  padding: 4px 8px;
  text-align: center;
`;

const AgentJoinedNotification = () => {
  const { t } = useTranslation();

  return (
    <SWrapper>
      <SContainer data-test="agent-joined-notification">
        <CheckCircleOutlineIcon
          size="16"
          color={colors.COLOR_OMILIA_PURPLE_900}
        />
        {t('messages.agentJoined')}
      </SContainer>
    </SWrapper>
  );
};

export default AgentJoinedNotification;
